import { useState, useEffect } from "react";
import { Calendar, DateObject } from "react-multi-date-picker";
import { weekDaysArray, months } from "utils/constants/onboardingStep";

const DesktopDatePicker = ({
  showButtons,
  isMultiple,
  handleDatePicker,
  selectedValue,
  handleMultipleDates,
  value,
  disableMonthYearPicker,
  multipleValues,
  isRendered,
}) => {
  const [date, setDate] = useState();
  const minSelectableDate = new DateObject().add(7, "days");

  let initialState = [];
  let currentDate = new DateObject();

  if (isMultiple) {
    const today = new DateObject();
    currentDate = today.add(value - 1, "month");

    if (multipleValues && Object.keys(multipleValues).length > 0) {
      const [currentMonthName] = Object.keys(multipleValues);
      const selectedDates = multipleValues[currentMonthName];

      initialState = selectedDates?.map((dateString) => {
        const [day, month, year] = dateString?.split("-")?.map(Number);
        return new DateObject({ day, month, year });
      });
    } else {
      initialState = [];
    }
  }

  useEffect(() => {
    const defaultDate = new DateObject().add(6, "days");
    setDate(
      selectedValue
        ? new DateObject({ date: new Date(selectedValue) })
        : defaultDate
    );
  }, []);

  const handleDateChange = (newDate) => {
    if (isMultiple) {
      handleMultipleDates(newDate);
    } else {
      setDate(newDate);
      handleDatePicker(newDate);
    }
  };

  return (
    <>
      {!isMultiple ? (
        <Calendar
          highlightToday={true}
          value={date}
          onChange={handleDateChange}
          buttons={showButtons}
          weekDays={weekDaysArray}
          months={months}
          numberOfMonths={3}
          disableYearPicker={disableMonthYearPicker}
          disableMonthPicker={disableMonthYearPicker}
          multiple={false}
          monthYearSeparator={" "}
          minDate={minSelectableDate}
        />
      ) : (
        <Calendar
          highlightToday={true}
          currentDate={currentDate}
          value={initialState}
          onChange={handleDateChange}
          buttons={showButtons}
          weekDays={weekDaysArray}
          months={months}
          disableYearPicker={disableMonthYearPicker}
          disableMonthPicker={disableMonthYearPicker}
          multiple={true}
          monthYearSeparator={" "}
          minDate={minSelectableDate}
          mapDays={({ date }) => {
            let jsDate;

            try {
              jsDate = date?.toDate();
            } catch (e) {
              return { disabled: true };
            }
            const isValid = jsDate instanceof Date && !isNaN(jsDate.getTime());

            return {
              disabled:
                (isValid && jsDate < minSelectableDate.toDate()) || !isValid,
            };
          }}
        />
      )}
    </>
  );
};

export default DesktopDatePicker;
